import React, { useEffect, useState } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import {
  FaPencilAlt,
  FaTimes,
  FaPhoneAlt,
  FaEnvelope,
  FaLandmark,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Wrapper from '../../components/Wrapper';
import ProfilePictureModal from './ProfilePictureModal';
import UpdateFieldOfficerProfile from './UpdateFieldOfficerProfile';

import {
  fetchFieldOfficerInfo,
  fetchFieldOfficerFarmers,
  fetchFieldOfficerAnalytics,
} from '../../store/features/fieldOfficerInfo';

import { hasPermission } from '../../hooks/usePermission';
import defaultProfileImg from '../../assets/Images/defaultProfileImg.jpg';

const FieldOfficerProfile = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [editInfo, setEditInfo] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const {
    fieldOfficerInfo,
    status,
  } = useSelector((state) => state.fieldOfficerInfo);

  /* FETCH DATA */
  useEffect(() => {
    dispatch(fetchFieldOfficerInfo({ id }));

    if (hasPermission('fieldOfficers:farmers')) {
      dispatch(fetchFieldOfficerFarmers({ id }));
    }

    if (
      hasPermission('fieldOfficers:reports') ||
      hasPermission('fieldOfficers:samples')
    ) {
      dispatch(fetchFieldOfficerAnalytics({ id }));
    }
  }, [id, dispatch]);

  if (status === 'loading') {
    return (
      <Wrapper>
        <h3>Loading...</h3>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <div className="profile-page w-100">
        <Row className="my-5">
          {/* LEFT PROFILE CARD */}
          <Col md={6}>
            <Card className="p-0 rounded-4">
              <Card.Body className="p-0">
                {/* HEADER */}
                <div className="row align-items-center p-md-5 p-4">
                  <div className="col-md-auto text-center mb-3 mb-md-0">
                    <div
                      className="rounded-circle bg-primary d-flex align-items-center justify-content-center mx-auto"
                      style={{ width: 140, height: 140, cursor: 'pointer' }}
                      onClick={() => setModalShow(true)}
                    >
                      <div className="overflow-hidden rounded-circle w-100 h-100">
                        <img
                          src={
                            fieldOfficerInfo.profile_picture &&
                              fieldOfficerInfo.profile_picture !== 'Default.jpg'
                              ? fieldOfficerInfo.profile_picture
                              : defaultProfileImg
                          }
                          alt="profile"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md text-center">
                    <h1 className="fw-bold text-md-start">
                      {fieldOfficerInfo.name}
                    </h1>
                  </div>
                </div>

                {/* DETAILS */}
                <div className="bg-light rounded-bottom-4 p-md-5 p-4">
                  <div className="position-relative">
                    <div className="position-absolute top-0 end-0">
                      {!editInfo ? (
                        <FaPencilAlt size={18} onClick={() => setEditInfo(true)} />
                      ) : (
                        <FaTimes size={22} onClick={() => setEditInfo(false)} />
                      )}
                    </div>

                    {!editInfo && (
                      <div className="fs-5">
                        <Row className="my-3">
                          <Col xs="auto"><FaPhoneAlt /></Col>
                          <Col>+91 {fieldOfficerInfo.mobile_no}</Col>
                        </Row>

                        <Row className="my-3">
                          <Col xs="auto"><FaEnvelope /></Col>
                          <Col>{fieldOfficerInfo.email_id || 'NA'}</Col>
                        </Row>

                        <Row className="my-3">
                          <Col xs="auto"><FaLandmark /></Col>
                          <Col>{fieldOfficerInfo.address}</Col>
                        </Row>

                        <Row className="my-3">
                          <Col xs="auto"><FaMapMarkerAlt /></Col>
                          <Col>
                            {fieldOfficerInfo.city}, {fieldOfficerInfo.state} -{' '}
                            {fieldOfficerInfo.pincode}
                          </Col>
                        </Row>
                      </div>
                    )}

                    {editInfo && (
                      <UpdateFieldOfficerProfile userData={fieldOfficerInfo} />
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* RIGHT ACTIONS */}
          <Col md={6}>
            <Card className="rounded-4 mb-3">
              <Card.Body>
                <h3 className="fw-bold text-center">Field Officer Activities</h3>

                {hasPermission('fieldOfficers:farmers') && (
                  <button
                    className="btn btn-dark w-100 my-2"
                    onClick={() => navigate(`/field-officers/${id}/farmers`)}
                  >
                    View Farmers
                  </button>
                )}

                {hasPermission('fieldOfficers:samples') && (
                  <button
                    className="btn btn-dark w-100 my-2"
                    onClick={() => navigate(`/field-officer/samples/${id}`)}
                  >
                    Samples Booked 
                  </button>
                )}

                {hasPermission('fieldOfficers:reports') && (
                  <button
                    className="btn btn-dark w-100 my-2"
                    onClick={() => navigate(`/field-officer/reports/${id}`)}
                  >
                    Reports Generated 
                  </button>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <ProfilePictureModal
          fieldOfficerInfo={fieldOfficerInfo}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </div>
    </Wrapper>
  );
};

export default FieldOfficerProfile;
